import Vue from 'vue'
import Vuex, { Module } from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import firebase from 'firebase/app'

import { db, FieldValue, Timestamp } from '../db'

const FETCH_LIMIT = 45

class AutoId {
    static newId(): string {
        // Alphanumeric characters
        const chars =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let autoId = '';
        for (let i = 0; i < 20; i++) {
            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return autoId;
    }
}

export const deckDetail: Module<any, any> = {
    namespaced: true,
    state: {
        deck: null,
        cards: [],
        loading: false,
        loadingCards: false,
        currentPickedCard: null,
        loadingPick: false,
    },
    mutations: {
        ...vuexfireMutations,
        setDeck: (state, { deck }) => {
            state.deck = deck
        },
        setCards: (state, { cards }) => {
            state.cards = cards
        },
        setLoadingCards: (state, { loading }) => {
            state.loadingCards = loading
        },
        setLoading: (state, { loading }) => {
            state.loading = loading
        },
        setLoadingPick: (state, { loading }) => {
            state.setLoadingPick = loading
        },
        setPickedCard: (state, { card }) => {
            state.currentPickedCard = card;
        }
    },
    actions: {
        fetchDeck({ commit, state }, { deckId }) {
            commit('setLoading', { loading: true })
            const docRef = db.collection('decks').doc(deckId)
            docRef.get()
                .then(doc => {
                    if (!doc.exists) {
                        return
                    }
                    const deck = doc.data()
                    commit('setDeck', { deck })
                })
                .finally(() => {
                    commit('setLoading', { loading: false })
                })
        },
        fetchCards({ commit, state }, { deckId }) {
            commit('setLoadingCards', { loading: true })
            const ref = db.collection(`decks/${deckId}/cards`)
                .orderBy("createdAt", "asc")
                .limit(FETCH_LIMIT)
            ref.get()
                .then(snapshot => {
                    if (snapshot.empty) {
                        commit('setCards', { cards: [] })
                        return
                    }
                    const cards = snapshot.docs.map(doc => doc.data())
                    commit('setCards', { cards })
                }).finally(() => {
                    commit('setLoadingCards', { loading: false })
                })
        },
        randomPick({ commit }, { cards }) {
            commit('setLoadingPick', { loading: true })
            const randomIndex = Math.floor(Math.random() * cards.length);
            commit('setPickedCard', { card: cards[randomIndex] })
            commit('setLoadingPick', { loading: false })
        }
    },
    getters: {
        getDeck: (state) => {
            return state.deck
        },
        getCards: (state) => {
            return state.cards.sort((a: any, b: any) => a.createdAt.toDate() > b.createdAt.toDate() ? -1 : 1)
        },
        getLoading: (state) => {
            return state.loading
        },
        getLoadingCards: (state) => {
            return state.loadingCards
        },
        getLoadingPick: (state) => {
            return state.loadingPick
        },
        currentPickedCard: (state) => {
            return state.currentPickedCard;
        }
    }
}